import styled from 'styled-components'
import { colors } from "../../branding";


export const StyledResources = styled.section`
  background-color: ${colors.pale};
  width: 100vw;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 50px;

  a {
    background-image: linear-gradient(to right bottom, ${colors.blueMidLight} 0%, ${colors.blueDark} 100%);
    background-color: ${colors.blueDark};
    color: ${colors.light};
    padding: 10px 20px;
    font-size: inherit;
    font-weight: bold;
    border-radius: 5px;
    min-width: 200px;
    margin: 10px;
    text-decoration: none;
    transition: all .2s ease-in-out;

    svg {
      height: 20px;
      width: 20px;
      vertical-align: middle;
      margin: 0 5px 0 -10px;
    }

    :hover {
      transform: scale(1.05);
    }

  }

  & .btn:hover {
    opacity: .8;
  }

  & h2 {
    margin: 20px;
  }

`